import React, { Component } from 'react'
import { Row, Badge } from 'react-bootstrap'
import moment from 'moment'

class CamposReimpresionComprobante1 extends Component {
  render () {
    const { formValues } = this.props
    return (
      <div className='campos-ingreso-paso3'>
        <Row>
          <h3>Fecha: </h3>
          <h3><Badge variant='secondary'>{
            moment.unix(formValues.fechaDeIngreso).tz('America/Argentina/Buenos_aires').format('YYYY-MM-DD')
          }</Badge></h3>
        </Row>
        <Row>
          <h3>Número CP: </h3>
          <h3><Badge variant='secondary'>{
            formValues.numero
          }</Badge></h3>
        </Row>
        <Row>
          <h3>Exportador: </h3>
          <h3><Badge variant='secondary'>{
            formValues.exportador
          }</Badge></h3>
        </Row>
        <Row>
          <h3>Patente: </h3>
          <h3><Badge variant='secondary'>{
            formValues.camion
          }</Badge></h3>
        </Row>
        <Row>
          <h3>CTG: </h3>
          <h3><Badge variant='secondary'>{
            formValues.ctg
          }</Badge></h3>
        </Row>
      </div>
    )
  }
}

export default CamposReimpresionComprobante1
